import * as React from "react";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";

// Abas de todas as telas do Reference Data: a ativa é amarela (cor de ação do design) com texto navy.
const ACTIVE_TAB =
  "data-[state=active]:bg-[#ffc83d] data-[state=active]:text-[#08254c] data-[state=active]:font-semibold data-[state=active]:shadow-none";

export const ReferenceDataTabs = Tabs;
export const ReferenceDataTabsList = TabsList;
export const ReferenceDataTabsContent = TabsContent;

export const ReferenceDataTabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsTrigger>,
  React.ComponentPropsWithoutRef<typeof TabsTrigger>
>(({ className, ...props }, ref) => (
  <TabsTrigger ref={ref} className={cn(ACTIVE_TAB, className)} {...props} />
));
ReferenceDataTabsTrigger.displayName = "ReferenceDataTabsTrigger";
